import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Divider } from "@bookips/sds";
import { BillingMethodSelector } from "./BillingMethodSelector";
import { BillingNoticeSection } from "./BillingNoticeSection";
import { BillingTermsAgreement } from "./BillingTermsAgreement";
/**
 * 월구독(빌링) 결제방법 영역
 *
 * 빌링에는 토스가 제공하는 결제수단 선택 위젯이 없으므로 결제수단·약관 동의 UI를 직접 렌더한다.
 * 상태는 CheckoutView의 useSubscriptionBilling이 소유하고, 실제 등록 요청은
 * 우측 sticky 패널(CheckoutPayment)의 결제 CTA에서 시작된다.
 */ export const SubscriptionBilling = (param)=>{
    let { method , onMethodChange , agreements , allChecked , onToggleTerm , onToggleAllTerms  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("mt-6 flex flex-col gap-5 px-6 pb-6 max-sm:px-5"),
        children: [
            /*#__PURE__*/ _jsx(BillingMethodSelector, {
                method: method,
                onMethodChange: onMethodChange
            }),
            /*#__PURE__*/ _jsx(BillingTermsAgreement, {
                agreements: agreements,
                allChecked: allChecked,
                onToggleTerm: onToggleTerm,
                onToggleAllTerms: onToggleAllTerms
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx(BillingNoticeSection, {})
        ]
    });
};
